import React from 'react';
import { connect } from 'react-redux';
import styled, { ThemeProvider, withTheme } from 'styled-components';
import { get, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { getCurrentBreadcrumbsList } from '../../../redux/selector/questions';
import { getBreadcrumbStatus } from '../../../util';

const defaultProgressTheme = {
  borderRadius: '8px',
  boxShadow: '0px 0px 15px 5px rgba(0, 0, 0, 0.2)',
  border: 'none',
  labelColor: '#767676',
  percentageColor: '#2965cc',
  percentageFontFamily: 'Avenir-Heavy',
  percentageFontWeight: 'normal',
  progressHeight: '8px',
  progressPendingColor: '#b3b3b3',
  progressDoneColor: '#2965cc',
  progressLabelBottom: false,
};

const Layout = styled.div`
  height: 80px;
  background: #ffffff;
  border-radius: ${({ theme }) => theme.borderRadius};
  border: ${({ theme }) => theme.border};
  margin-bottom: 10px;
  box-shadow: ${({ theme }) => theme.boxShadow};
  @media (min-width: 900px) {
    width: 90%;
    // max-width: 320px;
    height: 80px;
    background: #ffffff;
    border-radius: ${({ theme }) => (theme.borderRadius !== '0px' ? '10px' : '0px')};
  }
  @media (max-width: 899px) {
    border-radius: ${({ theme }) => (theme.borderRadius !== '0px' ? '10px' : '0px')};
    margin: 10px 5%;
  }
`;

const InfoContainer = styled.div`
  padding: 13px 0 3px 20px;
`;

const Label = styled.span`
  color: ${({ theme }) => theme.labelColor};
  font-size: 14px;
  @media (max-width: 767px) {
    align-self: flex-start;
  }
`;

const Percentage = styled.span`
  color: ${({ theme }) => theme.color};
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  @media (min-width: 481px) and (max-width: 767px) {
    align-self: flex-end;
  }
  @media only screen and (min-width: 320px) and (max-width: 480px) {
    align-self: flex-end;
  }
`;
const ProgressHolder = styled.div`
  width: 100%;
  height: 8px;
  display: flex;
  flex-direction: row;
  background-color: ${({ theme }) => theme.progressPendingColor};
  border-bottom-right-radius: ${({ borderRadius }) => borderRadius};
  border-bottom-left-radius: ${({ borderRadius }) => borderRadius};
  overflow: hidden;
  @media (min-width: 481px) and (max-width: 767px) {
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
  }
  @media only screen and (min-width: 320px) and (max-width: 480px) {
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
  }
  @media (forced-colors: active) {
    background: Highlight !important;
  }
`;
const Done = styled.div`
  width: ${(props) => `${props.percentage}%`};
  background-color: ${({ theme }) => theme.progressDoneColor};
  transition: all 0.5s linear;
  @media (forced-colors: active) {
    background: WindowText !important;
  }
`;

const FlexedDiv = styled.div`
  flex: 1;
`;

const Progress = ({ progress, theme }) => {
  const progressTheme = get(theme, 'config.theme.global.breadcrumb.progress', defaultProgressTheme);

  return (
    <ThemeProvider theme={ progressTheme }>
      <Layout name='layout'>
        <InfoContainer id='global-application-progress' name='info-container'>
          <FlexedDiv name='flexed-div'>
            <Label id='progress-label'>Application Progress</Label>
          </FlexedDiv>
          <FlexedDiv name='flexed-div'>
            <Percentage id='progress-indication'>{`${progress}% Complete`}</Percentage>
          </FlexedDiv>
        </InfoContainer>
        <ProgressHolder name='progress-holder'>
          <Done name='done' percentage={ progress } />
        </ProgressHolder>
      </Layout>
    </ThemeProvider>
  );
};

Progress.propTypes = {
  progress: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => {
  let activeSectionQuestions;
  let progress = 0;
  const breadcrumbs = getCurrentBreadcrumbsList(state);
  const [activeBc] = getBreadcrumbStatus(breadcrumbs || []);
  if (activeBc.length > 0) {
    activeSectionQuestions = state.questions.sections[activeBc[0].id];
    progress = isEmpty(activeSectionQuestions[activeSectionQuestions.length - 1])
      ? 0
      : activeSectionQuestions[activeSectionQuestions.length - 1].otherParams.question_progress;
  }
  return {
    screenViewport: state.meta.screenViewport,
    progress,
  };
};

export default connect(mapStateToProps)(withTheme(Progress));
